import { MOBILE_HOTSPOTS_VIEWS } from './constants';

export const getNextMobileHotspotsView = (mobileHotspotsView) => {
  switch (mobileHotspotsView) {
    case MOBILE_HOTSPOTS_VIEWS.SWAPPING_HOTSPOTS_ONLY:
      // Show all hotspots with swap styling next time hotspots
      // are displayed
      return MOBILE_HOTSPOTS_VIEWS.ALL_HOTSPOTS_WITH_SWAP_STYLING;
    default:
      return mobileHotspotsView;
  }
};
